import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import First from './First';
import DataList from './DataList';
import './TreeList.css';

class App extends Component {
  state={ width: 257 }
  componentDidMount () {
    const { updateWidth } = this.props;
    const { width } = this.state;
    updateWidth(width);
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { hide: prevHide } = prevProps;
    const { hide } = this.props;
    if (prevHide !== hide) { this.changeHide(); }
  }

  changeHide=() => {
    const { hide, updateWidth } = this.props;
    if (this.timer)clearInterval(this.timer);
    if (hide) {
      this.setState({ width: 0 });
    } else {
      this.setState({ width: 257 });
    }
    this.timer = setInterval(() => {
      const { width } = this.state;
      updateWidth(width);
      clearInterval(this.timer);
    }, 280);
  }

  render () {
    const { pathAry = [] } = this.props;
    const { width } = this.state;
    return (
      <div style={{ width, height: '100%', overflow: 'hidden', transition: 'width .25s' }}>
        <div style={{ width: 257, height: '100%', display: 'flex', flexDirection: 'row' }}>
          <div style={{ marginTop: 22, marginBottom: 26, marginLeft: 24, marginRight: 13, backgroundColor: '#B2D6DB', flex: 1, borderRadius: 30, paddingTop: 28, paddingBottom: 28, display: 'flex', boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ flex: 1, overflowY: 'auto' }}>
              {DataList.map((o, i) => {
                if (pathAry.indexOf(o.path) > -1) { return <First key={o.text} data={o} />; } else return null;
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  pathAry: state.data.PathAry,
});
const mapDispatchToProps = dispatch => ({
  updateWidth: value => dispatch({ type: 'treeWidth', value }),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
